export default __webpack_public_path__ + "static/test_1_5-884c36abeb14038015afac0ecc604617.png";